import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import {
  UncontrolledCollapse,
  FormGroup,
  CustomInput,
  Label,
} from "reactstrap";
import Carousel from "react-bootstrap/Carousel";

import shop from "../../images/shop.jpeg";
import shop2 from "../../images/shop2.jpg";
import photo from "../../images/dp.jpg";
import "./styles.scss";
import LayoutThemeTwo from "../../components/LayoutThemeTwo/LayoutThemeTwo";
import StoreItemThemeTwo from "../../components/StoreItemThemeTwo/StoreItemThemeTwo";
import { Link, useHistory } from "react-router-dom";

import ViewMore from "../../components/ViewMore/ViewMore";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchAllProducts, fetchSearch } from "../../redux/actions/products";
import { fetchCategory } from "../../redux/actions/category";


import storeId from "../../config/storeId";

const items = [
  {
    src: shop,
    altText: "Slide 1",
    caption: "Slide 1",
  },
  {
    src: shop2,
    altText: "Slide 2",
    caption: "Slide 2",
  },
];

const MarketTwo = (props) => {
  const store = storeId();
  const history = useHistory();
  const [products, setProducts] = useState([]);
  const [banner, setBanner] = useState([]);
  const [category, setCategory] = useState([]);
  const [pageCount, setPage] = useState(12);
  const [search, setSearch] = useState({ text: "" });
  const [check, setCheck] = useState(false);

  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  function viewMore() {
    props.fetchAllProducts(pageCount);
    setPage(pageCount + 8);
  }

  function handleChange(e) {
    e.preventDefault();
    setCheck(true);
    props.fetchSearch(search);
  }

  useEffect(() => {
    //props.fetchCategory();
    props.fetchAllProducts();
  }, []);

  useEffect(() => {
    if (props.products.products.data) {
      setProducts(props.products.products.data.product);
      setBanner(props.products.products.data.store.banners);
    }
  }, [props.products.products]);

  // useEffect(() => {
  //   if (props.search.search.data) {
  //     setProducts(props.search.search.data.product);
  //     setCheck(false);
  //   }
  // }, [props.search.search.data]);

  useEffect(() => {
    if (props.category.category.data) {
      setCategory(props.category.category.data.store.categories);
    }
  }, [props.category.category]);

  return (
    <LayoutThemeTwo>
      <section>
        <section className="carousel-container">
          {/* <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
    >
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </Carousel> */}

          <Carousel interval={3000}>
            {banner.length < 1 ? (
              <Carousel.Item>
                <img
                  className="d-block w-100 carosel"
                  src={shop}
                  alt="First slide"
                />
              </Carousel.Item>
            ) : (
              banner.map((item, i) => {
                return (
                  <Carousel.Item>
                    <img
                      className="d-block w-100 carosel"
                      src={item.url}
                      alt="First slide"
                    />
                  </Carousel.Item>
                );
              })
            )}
          </Carousel>
        </section>

        <h2 className="text-center p-5">{store}</h2>

        <section className="row store-section-theme-two">
          {(products || []).map((item, i) => {
            return (
              <div className="col-md-3 col-lg-3 col-xs-12 store" key={i}>
                <StoreItemThemeTwo
                  price={item.net_price}
                  name={item.product_name}
                  desc={item.description}
                  photo={item.images[0]}
                  action={() => history.push(`/product/${item.product_slug}`)}
                />
              </div>
            );
          })}

          {products.length < 1 && (
            <h3 className="text-center p-5">No product is available</h3>
          )}
        </section>
        <ViewMore viewHandler={viewMore} />
        <section className="container-fluid">
          <h4 className="text-center p-5">ABOUT XYZ Limited</h4>
          <div className="row">
            <div className="col-md-6">
              <img src={photo} alt="Los ngeles" width="50%" />
            </div>
            <div className="col-md-6 ">
              <p>
                Our mission is threefold - to foster designer-artisan
                collaborations, inspire consumers to value provenance and
                process, and pioneer industry change and sustainability for
                rural textile communities.
              </p>
              <strong>what we do</strong>
              <p>ladies wear</p>
              <p>men wear</p>
              <strong>address</strong>
              <p>Shop 15b Balogun Market, Lagos.</p>
              <strong>follow us</strong>
              <p>
                <i class="fa fa-facebook" aria-hidden="true"></i>
              </p>
            </div>
          </div>
        </section>
        <section className="container-fluid">
          <h4 className="text-center p-5">CONTACT XYZ Limited</h4>
          <div className="row">
            <div className="col-md-6">
              <img src={photo} alt="Los ngeles" width="50%" />
            </div>
            <div className="col-md-6 ">
              <p>
                Our mission is threefold - to foster designer-artisan
                collaborations, inspire consumers to value provenance and
                process, and pioneer industry change and sustainability for
                rural textile communities.
              </p>
              <strong>what we do</strong>
              <p>ladies wear</p>
              <p>men wear</p>
              <strong>address</strong>
              <p>Shop 15b Balogun Market, Lagos.</p>
              <strong>follow us</strong>
              <p>
                <i class="fa fa-facebook" aria-hidden="true"></i>
              </p>
            </div>
          </div>
        </section>
      </section>
    </LayoutThemeTwo>
  );
};

MarketTwo.propTypes = {
  products: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  products: state.products,
  category: state.category,
  search: state.search,
});

const pageActions = {
  fetchAllProducts,
  fetchCategory,
  fetchSearch,
};
export default connect(mapStateToProps, pageActions)(MarketTwo);
